import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { RegisterInvoiceService } from '../../service/invoice/RegisterInvoiceService';
import { TokenService } from '../he-thong/chung-thu-so/TokenService';
import { ReportService } from '../bao-cao/ReportService';
import { TenantCompanyService } from '../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../service/UserStorage';

import { FormatDisplay } from '../../shared/format';
import { ROLE } from '../../Constant';
import EventEmitter from '../../utils/EventEmitter';
import { useDialogRegisterInvoice } from './item/DialogRegisterInvoice';
import { InfoDialogService } from '../../AppInfoDialog';
import moment from 'moment';
export default function Dashboard() {
  const navigate = useNavigate()
  const [summaryReport, setSummaryReport] = useState(null);
  const [licence, setLicence] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [tenantData, setTenantData] = useState(null);
  const [counterInvoice, setCounterInvoice] = useState(null);
  const [isDisabledReloadCounterInvoice, setIsDisabledReloadCounterInvoice] = useState(false)
  let container = [];
  let userName = AppStorage.get('UserName');
  
  useEffect(() => {
    setDisplaySelectInvoice(true);
    // showNotification();
    RegisterInvoiceService.getCounterStatusInvoice({maxResultCount: 1000, userName }).then(({items}) => {
      setRegisterInvoices(items);
    });
    TokenService.getList({Used: true, MaxResultCount: 1000,userName, Sorting: 'expireDate', SortType: 'DESCEND'}).then(({items}) => {
      const arr1 = [], arr2 = [];
      items.forEach(item => {
        const expirationDays = (new Date(item.expireDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24);
        item.expirationDays = expirationDays;
        if (expirationDays > 0 && expirationDays < 30) {
          arr1.push(item);
        } else {
          arr2.push(item);
        }
      });
      setTokens([...arr1, ...arr2]);
    });
    ReportService.getSummaryReport().then(data => {
      data.forEach((item, index) => {
        container.push(
          <b key={index} style={{ color: 'white', fontSize: '12px', display: 'inherit', padding: '2px 0px', textAlign: 'left' }}>{item.productName}: Dùng {item.usedQuantity} / {item.registeredQuantity}, còn lại {item.registeredQuantity - item.usedQuantity}</b>
        );
      });
      setLicence(container);
    });

    ReportService.getCounterInvoice().then(data => {
      setCounterInvoice(data);
    })

    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      document.title = data.name + '-' + data.taxCode;
      AppStorage.set('tenantInfo', JSON.stringify(data));
      setTenantData(data);
      EventEmitter.emit("changeTenantInfo", data);
    });

    RegisterInvoiceService.getInvoiceSerialByYear().then(data => {
      if (!data.hiddenDialog) {
        showRegisterInvoiceDialog();
      }
    });

  }, []);

  const { renderRegisterInvoice, showRegisterInvoiceDialog } = useDialogRegisterInvoice({
    registerInvoices,
    registerInvoice: 1,
    selectionMode: "checkbox",
  });

  const showNotification = () => {
    InfoDialogService.show({
      header: 'Ký điện tử không thành công',
      width: '50rem',
      body: (
        <div className="grid">
          <div className="col-2 text-center">
            <img src="/images/usb-not-connected-icon.png" alt="" style={{ width: '80%' }} />
          </div>
          <div className="col-10">
            <p>Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn</p>
            <p><b>1.</b> Bạn chưa cài đặt công cụ <b>M-INVOICE Plugin</b></p>
            <p className="pl-4">Hãy cài đặt M-INVOICE Plugin để tiếp tục.</p>
            <p className="pl-4">
              <a href="https://plugin.minvoice.com.vn/MinvoicePlugin_Test/setup.exe" rel="noreferrer" target="_blank" className="text-lg mr-5"><i className="pi pi-download mr-2"></i>Tải bộ cài</a>
              <a href={'https://www.youtube.com/playlist?list=PLpmokHjV2pDpdSxt4wai1ZX6-dR8EKp21'} rel="noreferrer" target="_blank" className="text-lg"><i className="pi pi-info-circle mr-2"></i>Xem hướng dẫn cài đặt</a>
            </p>
            <p><b>2.</b> Bạn đã cài đặt công cụ <b>M-INVOICE Plugin</b></p>
            <p className="pl-4">Hãy mở công cụ M-INVOICE Plugin trước khi ký điện tử</p>
            <p className="pl-4">
              <a href={`minvoice:${AppStorage.get('tenant')}`} className="text-lg"><i className="pi pi-info-circle mr-2"></i>Mở M-INVOICE Plugin</a>
            </p>
          </div>
        </div>
      )
    });
  }

  const reloadCounterInvoice = (e) => {
    e.stopPropagation()
    if (!isDisabledReloadCounterInvoice) {
      setIsDisabledReloadCounterInvoice(true)
      ReportService.reloadCounterInvoice().then(data => { 
          setCounterInvoice(data); 
          RegisterInvoiceService.getCounterStatusInvoice({maxResultCount: 1000, userName}).then(({items}) => {
            setRegisterInvoices(items);
          });
      });
      setTimeout(() => { setIsDisabledReloadCounterInvoice(false) }, 1000 * 60 * 3);
    }
  }

  return (
    <div className="grid pt-3">
      {/* <div className="col-12 lg:col-6 xl:col-3 p-3 pb-0">
        <Link to="/he-thong/doanh-nghiep/thong-tin-doanh-nghiep" style={{height: '100%'}}>
          <div className="card grid p-3" style={{background: '-webkit-linear-gradient(left, #E779EE 0%, #8F69E5 100%)', height: '100%'}}>
            <div className="col-3 text-center">
              <i className="pi pi-pencil" style={{color: 'rgba(255, 255, 255, 0.17)', fontSize: '50px'}}/>
            </div>
            <div className="col-9">
              <div className="mb-1" style={{color: 'white', fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase'}}>Thông tin doanh nghiệp</div>
              <span className="mb-1" style={{color: 'white', fontSize: '12px', display: 'block'}}>{tenantData?.name}</span>
              <span style={{color: 'white', fontSize: '12px', display: 'block'}}>MST: {tenantData?.taxCode}</span>
            </div>
          </div>
        </Link>
      </div> */}
      <div className="col-12 lg:col-12 xl:col-6 p-3 pb-0">
        <div className="card grid p-3 cursor-pointer" style={{ background: '-webkit-linear-gradient(left, #2FCAC4 0%, #10ABCC 100%)', height: '100%' }} onClick={() => navigate("/hoa-don")}>
          <div className='col-12 grid'>
            <div className='col-1 mb-2'>
              <i className="pi pi-check-square" style={{ color: 'rgba(255, 255, 255, 0.17)', fontSize: '50px' }} />
            </div>
            <div className='col-11 flex flex-column'>
              <span style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '3px' }}>Thống kê hóa đơn cần xử lý</span>
              <span style={{ color: 'white', fontSize: '12px' }}>Hóa đơn ĐANG GỬI, CHỜ KÝ (Trong 1 tháng gần nhất)</span>
            </div>
            <div className='col-6'>
              <span style={{ color: 'white', fontSize: '15px', fontWeight: 'bold' }}>ĐANG GỬI</span>
              <br />
              <span style={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}>{counterInvoice?.totalSending}</span>
            </div>
            <div className='col-6'>
              <span style={{ color: 'white', fontSize: '15px', fontWeight: 'bold' }}>CHỜ KÝ</span>
              <br />
              <span style={{ color: 'white', fontSize: '32px', fontWeight: 'bold' }}>{counterInvoice?.totalWaitSign}</span>

            </div>
            <div className='col-12 flex justify-content-end align-items-center gap-2'>
              <span style={{ color: 'white', fontSize: '15px', fontWeight: 'bold' }}>Cập nhật lúc {moment(counterInvoice?.dateTimeCount).format('HH:mm DD/MM/YYYY')}</span>
              <i className="pi pi-sync" style={{ color: 'white', fontSize: '24px' }} onClick={e => reloadCounterInvoice(e)} />
            </div>
          </div>
        </div>
      </div >
      <div className="col-12 lg:col-6 xl:col-3 p-3 pb-0">
        <Link to="/hoa-don" style={{ height: '100%' }}>
          <div className="card grid p-3" style={{ background: '-webkit-linear-gradient(left, #57A0E0 0%, #7E87EB 100%)', height: '100%' }}>
            <div className="col-3 text-center">
              <i className="pi pi-book" style={{ color: 'rgba(255, 255, 255, 0.17)', fontSize: '50px' }} />
            </div>
            <div className="col-9">
              <div className="mb-1" style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase' }}>Danh sách hoá đơn</div>
              <span style={{ color: 'white', fontSize: '12px' }}>Quản lý lập, phát hành và xử lý hoá đơn</span>
            </div>
            <div className="col-12 text-right">
              {licence}
            </div>
          </div>
        </Link>
      </div>
      <div className="col-12 lg:col-6 xl:col-3 p-3 pb-0">
        <Link to="/xu-ly-sai-sot/thong-bao-04-ss-hddt" style={{ height: '100%' }}>
          <div className="card grid p-3" style={{ background: '-webkit-linear-gradient(left, #f7a9a1 0%, #FF5C4C 100%)', height: '100%' }}>
            <div className="col-3 text-center">
              <i className="pi pi-exclamation-triangle" style={{ color: 'rgba(255, 255, 255, 0.17)', fontSize: '50px' }} />
            </div>
            <div className="col-9">
              <div className="mb-1" style={{ color: 'white', fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase' }}>Thông báo HĐ sai sót</div>
              <span style={{ color: 'white', fontSize: '12px' }}>Thông báo hoá đơn điện tử có sai sót đến cơ quan thuế theo mẫu 04/SS-HĐĐT</span>
            </div>
          </div>
        </Link>
      </div>

      <div className="col-12 xl:col-6">
        <div className="card" style={{ height: '100%' }}>
          <div className="grid">
            <div className="col-6">
              <h5>Lập hóa đơn nhanh</h5>
            </div>
          </div>
          <DataTable value={registerInvoices} rows={5} paginator showGridlines stripedRows size="small" responsiveLayout="scroll">
            <Column field="creationTime" header="Ngày khởi tạo" style={{ width: '150px', textAlign: 'center' }} body={(data) => FormatDisplay.date(data.creationTime)} />
            <Column field="symbolCode" header="Ký hiệu" style={{ width: '150px', textAlign: 'center' }} />
            <Column field="sending" header="Số lượng ĐANG GỬI" style={{ width: '150px', textAlign: 'center' }} body={(data) => (
              <>
                {
                  data.sending === 0 && <div className='flex justify-content-center'>
                    <div className='w-6 border-round-lg text-2xl font-semibold'>
                      {data.sending}
                    </div>
                  </div>
                }
                {
                  data.sending > 0 && <div className='text-white flex justify-content-center'>
                    <div className='p-2 w-6 bg-red-500 border-round-lg text-2xl font-semibold'>
                      {data.sending}
                    </div>
                  </div>
                }
              </>
            )} />
            <Column field="waitSign" header="Số lượng CHỜ KÝ" style={{ width: '150px', textAlign: 'center' }} body={(data) => (
              <>
                {
                  data.waitSign === 0 && <div className=' flex justify-content-center'>
                    <div className='w-6 border-round-lg text-2xl font-semibold'>
                      {data.waitSign}
                    </div>
                  </div>
                }
                {
                  data.waitSign > 0 && <div className='text-white   flex justify-content-center'>
                    <div className='p-2 w-6 bg-yellow-500 border-round-lg text-2xl font-semibold'>
                      {data.waitSign}
                    </div>
                  </div>
                }
              </>
            )} />
            <Column header="Truy cập nhanh" style={{ width: '170px', textAlign: 'center' }} body={(data) => (
              <Link to={`/hoa-don?registerInvoiceId=${data.id}`}>
                <Button label="Lập hoá đơn" icon="pi pi-plus" className="p-button-sm" />
              </Link>
            )} />
          </DataTable>
        </div>
      </div>

      <div className="col-12 xl:col-6">
        <div className="card" style={{ height: '100%' }}>
          <div className="grid">
            <div className="col-6">
              <h5>Chứng thư số đăng ký</h5>
            </div>
            <div className="col-6 text-right">
              <Link to={`/phat-hanh/to-khai-dang-ky?action=create`}>
                <Button label="Thay đổi chứng thư số trên tờ khai" className="p-button-rounded p-button-outlined p-button-sm" />
              </Link>
            </div>
          </div>
          <DataTable value={tokens} rows={5} paginator showGridlines stripedRows size="small" responsiveLayout="scroll">
            <Column field="venderShortcut" header="Tổ chức cấp chứng thư" style={{ textAlign: 'center' }} />
            <Column field="serialNumber" header="Serial chứng thư" style={{ textAlign: 'center' }} />
            <Column field="dateFrom" header="Ngày có hiệu lực" style={{ width: '120px', textAlign: 'center' }} body={(data) => FormatDisplay.date(data.dateFrom)} />
            <Column field="expireDate" header="Ngày hết hạn" style={{ width: '120px', textAlign: 'center' }} body={(data) => FormatDisplay.date(data.expireDate)} />
            <Column header="Trạng thái" style={{ width: '150px', textAlign: 'center' }} body={(data) => (
              <div>
                {data.expirationDays > 0 &&
                  <div style={{ padding: '0.65625rem 1.09375rem' }}>
                    {data.expirationDays >= 30 &&
                      <b style={{ color: 'green' }}>Còn hạn</b>
                    }
                    {data.expirationDays < 30 &&
                      <b style={{ color: 'red' }}>Sắp hết hạn</b>
                    }
                  </div>
                }
                {data.expirationDays <= 0 &&
                  <div style={{ padding: '0.65625rem 1.09375rem' }}><b>Hết hạn</b></div>
                }
              </div>
            )} />
          </DataTable>
        </div>
      </div>
      {renderRegisterInvoice()}
      <div className="col-12">
        <img src="/images/Banner.jpeg" alt="" style={{ width: '100%' }} />
      </div>
    </div>
  );
}
